/**
 * @generated SignedSource<<ba626e581067c6055733b84c7b7a3b80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchRelatedItems_viewer$data = {
  readonly regionalInfo?: ReadonlyArray<{
    readonly regionsByZipCode: ReadonlyArray<{
      readonly displayName: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "useSbSharedItemTracking_viewer">;
  readonly " $fragmentType": "SbSharedNullSearchRelatedItems_viewer";
};
export type SbSharedNullSearchRelatedItems_viewer$key = {
  readonly " $data"?: SbSharedNullSearchRelatedItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedNullSearchRelatedItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedNullSearchRelatedItems_viewer",
  "selections": [
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "kind": "LinkedField",
              "name": "regionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSbSharedItemTracking_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6ed2858134b16c8a5d766218a8d67b8f";

export default node;
